'use client';

// Re-open the consent banner from anywhere (used on /privacy under
// the cookies section so users can change their mind).

export function ManageCookiesLink() {
  return (
    <button
      type="button"
      onClick={() => window.dispatchEvent(new Event('np:consent-open'))}
      className="underline hover:text-ink"
    >
      Manage cookie preferences
    </button>
  );
}
